<div class="auth-page">

  <!-- ── Left: Brand Panel ──────────────────────────────────────── -->
  <aside class="auth-brand" aria-hidden="true">

    <div class="brand-header">
      <div class="brand-icon">
        <img src="assets/icons/icon-192x192-grey.png" alt="" width="90%">
      </div>
      <h1 class="brand-name">{{ customBrandName() || 'CoSMoS' }}</h1>
      <p class="brand-subtitle">{{ 'login.app-subtitle' | translate }}</p>
      @if (customBrandName()) {
        <small class="brand-powered-by">Powered by CoSMoS Engineering</small>
      }
    </div>

    <div class="brand-visual">
      <div class="brand-feature">
        <div class="feature-icon"><i class="fa-solid fa-satellite-dish fa-xl"></i></div>
        <span class="feature-text">{{ 'login.feature-monitor' | translate }}</span>
      </div>
      <div class="brand-feature">
        <div class="feature-icon"><i class="fa-solid fa-chart-line fa-xl"></i></div>
        <span class="feature-text">{{ 'login.feature-analyze' | translate }}</span>
      </div>
      <div class="brand-feature">
        <div class="feature-icon"><i class="fa-solid fa-square-check fa-xl"></i></div>
        <span class="feature-text">{{ 'login.feature-certify' | translate }}</span>
      </div>
    </div>

    <p class="brand-tagline">{{ 'login.tagline' | translate }}</p>

  </aside>

  <!-- ── Right: Form Panel ──────────────────────────────────────── -->
  <main class="auth-form-panel">
    <div class="auth-form-container">

      <!-- Mobile brand header – visible only on small screens -->
      <div class="auth-mobile-brand" aria-hidden="true">
        <div class="mobile-brand-icon">
          <img src="assets/icons/icon-192x192-grey.png" alt="" width="100%">
        </div>
        <h1 class="mobile-brand-name">{{ customBrandName() || 'CoSMoS' }}</h1>
        <p class="mobile-brand-subtitle">{{ 'login.app-subtitle' | translate }}</p>
        @if (customBrandName()) {
          <small class="mobile-brand-powered-by">Powered by CoSMoS Engineering</small>
        }
        <p-divider />
      </div>

      @if (title) {
        <header class="form-header">
          <h2 class="form-title">{{ title }}</h2>
          @if (subtitle) {
            <p class="form-subtitle">{{ subtitle }}</p>
          }
        </header>
      }

      <!-- Page-specific form content -->
      <ng-content />

    </div>
  </main>

</div>
